import React from "react";

const Blank = props => {
  return <div style={{ backgroundColor: "#fff", width: "100%" }} />;
};
export default Blank;
